import { RESET_ALL_FILTERS } from '../appFilterAndSort/action-types';
import { resetOffers } from '../offers/actions';

export const middleware = (store) => (next) => (action) => {
  if (!action || !action.type) {
    return next(action);
  }
  switch (action.type) {
    case RESET_ALL_FILTERS: {
      resetOffers(store.dispatch);
      break;
    }
  }
  return next(action);
};
